import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import firebase, { database } from '../../../utils/firebase.js'
import './Aside.scss'


const timeFormat  = (sec) => {
    let date = new Date(sec)
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0'+minutes : minutes;
    let strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}


const Aside = ({ username, setDesState }) => {

    const langTxtDetails = useSelector(state => state.langTxtDetails)
    const eventDetails = useSelector(state => state.eventDetails)
    const user = useSelector(state => state.user)
    const { country } = user
    const {language, live, langCode} = langTxtDetails
    const [caption, setCaption] = useState([])
    const [comments, setComments] = useState([])
    const [commentUpdate, setCommentUpdate] = useState(true)

    useEffect(() => {

        if(live) {
            const enRef = database.ref(langCode)
            enRef.on('value', (el) => {
                let eData = []
                for(let id in el.val()) {
                    eData.push({id, ...el.val()[id]})
                }
                setCaption(eData)
            })
        } else {
            setCaption([])
        }
    }, [langCode, live]);


    useEffect(() => {
        if(eventDetails.id) {    
            const commentRef = firebase.database().ref('Events').child(eventDetails.id).child('Comments')
            commentRef.on('value', (el) => {
            let commentData = []
            let i
            for (let id in el.val()) {
                commentData.unshift(el.val()[id])
            }
            setComments(commentData)
        })
        }
        
        
        
    }, [commentUpdate, eventDetails.id])

    

    const handleCommentSubmit = (e) => {
        e.preventDefault()
        const commentRef = database.ref('Events').child(eventDetails.id).child('Comments')
        // const commentRef = firebase.database().ref('Events').child('-Mcn4hdIufQOrqBFuHHp').child('Comments')
        const com = {
            username: `${username} - ${country}`, 
            profilePicture: "", 
            createdAtDate: Date.now(), 
            comment: document.getElementById('comment').value, 
        }

        commentRef.push(com)
        setCommentUpdate(!commentUpdate)
        document.getElementById('comment').value = ''      
    }

    const handleScroll = () => {
        document.body.scrollTop = 0; 
        document.documentElement.scrollTop = 0
    }

    const handleEventDetails = () => {
        setDesState(prev => !prev)
        document.querySelector('.bot-mob').classList.toggle('hide')
    }


    return (
        <aside>
                    <div className='lang-heading'>
                        <h2>Language Caption</h2>
                        <p className='mob' onClick={handleEventDetails}>Event Details</p>
                    </div>
                    
                    <div className='container'>
                        <div className='speech-to-text'>
                            {live? caption.map(el => {
                                return (
                                    <p>{el.text}</p>
                                )
                            }) : <div className='not-live'>{language} Language Caption Is Not Live</div>}
                        </div>
                    </div>

                    <div className='comment'>
                        
                        <form action="" onSubmit={handleCommentSubmit}>
                            <textarea name="comment" placeholder='Post comment here...' required id="comment"></textarea>
                            <button type='submit'>COMMENT</button>
                        </form>

                        <div className='c-list .scroll-color-auto'>

                            {!comments? 
                                <div className="anima">
                                    loading
                                </div>
                                                 
                                : comments.map(el => {
                                return (
                                    <div className='c-posted'>

                                        <div className='c-details'>
                                            <div className="top">
                                                <p className='displayed-username'>{el.username.split(' ').filter(el => el.length > 0).map(el => {
                                                    return el[0].toUpperCase() + el.slice(1).toLowerCase()
                                                    }).join(' ')}
                                                </p>
                                                <p className='displayed-time'>{timeFormat(el.createdAtDate)}</p>
                                            </div>
                                            
                                            <p className='displayed-comment'>{el.comment}</p>
                                            <div className="line"></div>
                                        </div>
                                    </div>
                                )
                            })}
   
                        </div>
                    </div>

                    {/* <button className='btn-top desk' onClick={handleScroll}>^</button> */}
                </aside>
    )
}

export default Aside